/* Removes 4 digit dates in the format of "0000-0000", dates in the format of "0000 - Present", and the hyphens that follow the dates */

const regex =
  /([\d]{4})-(Present) - |([\d]{4}) - (Present) - |([\d]{4})-([\d]{4}) - |([\d]{4}) - ([\d]{4}) - /g;

const removeDatesAndHyphensFromString = (text: string) => {
  const formattedText = text.replace(regex, '');

  return formattedText;
};

export default removeDatesAndHyphensFromString;
